import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createTextVNode(" Drop your file here or "),
    /*#__PURE__*/ _createElementVNode("em", { class: "text-primary" }, "choose file"),
    /*#__PURE__*/ _createTextVNode(". ")
], -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_input_dropzone_file = _resolveComponent("input-dropzone-file");
    const _component_label_form = _resolveComponent("label-form");
    return (_openBlock(), _createBlock(_component_label_form, null, {
        default: _withCtx(() => [
            _createVNode(_component_input_dropzone_file, {
                options: _ctx.templateOptions,
                onChange: _ctx.handleTemplateChange
            }, {
                placeholder: _withCtx(() => [
                    _hoisted_1
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["options", "onChange"])
        ]),
        _: 1 /* STABLE */
    }));
}
